export const glassesCategories = [
  {
    title: 'Category',
    items: [
      'All Glasses',
      "Women's Glasses",
      "Men's Glasses",
      'Varifocals',
      'Reading Glasses',
    ],
  },
  {
    title: 'Shop by Shape',
    items: ['Round', 'Square', 'Cat Eye', 'Aviator', 'Wayfarer', 'Oversized'],
  },
  {
    title: 'Materials',
    items: ['Acetate', 'Metal', 'Titanium', 'Plastic', 'Wood', 'Carbon Fiber'],
  },
];

export const sunglassesCategories = [
  {
    title: 'By Style',
    items: ['Aviator', 'Wayfarer', 'Round', 'Cat Eye', 'Sport', 'Oversized'],
  },
  {
    title: 'Protection',
    items: ['UV400', 'Polarized', 'Mirrored', 'Gradient', 'Photochromic'],
  },
  {
    title: 'Activity',
    items: ['Driving', 'Beach', 'Sports', 'Fashion', 'Travel', 'Work'],
  },
  {
    title: 'Gender',
    items: ["Men's", "Women's", 'Unisex', 'Kids'],
  },
];

export const brandsCategories = [
  {
    title: 'Premium',
    items: ['Ray-Ban', 'Oakley', 'Tom Ford', 'Persol', 'Maui Jim'],
  },
  {
    title: 'Popular',
    items: ['Prada', 'Gucci', 'Versace', 'Dolce & Gabbana', 'Boss'],
  },
  {
    title: 'Luxury',
    items: ['Cartier', 'Chopard', 'Bulgari', 'Tiffany & Co'],
  },
  {
    title: 'Specialty',
    items: ['Nike', 'Adidas', 'Under Armour', 'Costa Del Mar'],
  },
];

export const boutiqueCategories = [
  {
    title: 'Services',
    items: [
      'Personal Fitting',
      'Style Consultation',
      'Lens Upgrade',
      'Repair Service',
    ],
  },
  {
    title: 'Exclusive',
    items: ['Limited Edition', 'Designer Collection', 'Custom Made', 'Vintage'],
  },
  {
    title: 'Personal Shopping',
    items: ['Virtual Appointment', 'Home Try-On', 'Concierge Service'],
  },
];

export const aiCategories = [
  {
    title: 'Virtual Try-On',
    items: ['AR Camera', '3D Fitting', 'Real-time Preview', 'Photo Upload'],
  },
  {
    title: 'Recommendations',
    items: ['Face Analysis', 'Style Match', 'Color Matching', 'Size Finder'],
  },
  {
    title: 'Face Analysis',
    items: ['Face Shape', 'Skin Tone', 'Features Detection', 'Best Fit'],
  },
];

// Legacy format for backward compatibility
export const legacyGlassesCategories = [
  { name: 'All Glasses', href: '/glasses' },
  { name: "Women's Glasses", href: '/glasses/women' },
  { name: "Men's Glasses", href: '/glasses/men' },
  { name: 'Varifocals', href: '/glasses/varifocals' },
  { name: 'Reading Glasses', href: '/glasses/reading' },
  { name: 'Glasses Accessories', href: '/glasses/accessories' },
];

export const legacySunglassesCategories = [
  { name: 'All Sunglasses', href: '/sunglasses' },
  { name: "Women's Sunglasses", href: '/sunglasses/women' },
  { name: "Men's Sunglasses", href: '/sunglasses/men' },
  { name: 'Prescription Sunglasses', href: '/sunglasses/prescription' },
  { name: 'Sunglasses Accessories', href: '/sunglasses/accessories' },
];

export const legacyLensCategories = [
  { name: 'Single Vision Lenses', href: '/lenses?type=single-vision' },
  { name: 'Progressive Lenses', href: '/lenses?type=progressive' },
  { name: 'Drive Safe Lenses', href: '/lenses?type=drive-safe' },
  { name: 'Office Lenses', href: '/lenses?type=office' },
  { name: 'Blue Light Protection', href: '/lenses?feature=blue-light' },
  { name: 'Anti-Reflective', href: '/lenses?feature=anti-reflective' },
];

export const legacyBrandsCategories = [
  { name: 'Ray-Ban', href: '/brands/ray-ban' },
  { name: 'Oakley', href: '/brands/oakley' },
  { name: 'Tom Ford', href: '/brands/tom-ford' },
  { name: 'Prada', href: '/brands/prada' },
  { name: 'Gucci', href: '/brands/gucci' },
  { name: 'All Brands', href: '/brands' },
];

export const legacyBoutiqueCategories = [
  { name: 'Boutique Special', href: '/boutique/special' },
  { name: 'Designer Glasses', href: '/boutique/designer-glasses' },
  { name: 'Designer Sunglasses', href: '/boutique/designer-sunglasses' },
  { name: 'Limited Edition', href: '/boutique/limited' },
];

export const legacyAiCategories = [
  { name: 'Virtual Try-On', href: '/ai' },
  { name: 'Face Analysis', href: '/ai/face-analysis' },
  { name: 'Style Recommendation', href: '/ai/style-recommendation' },
  { name: 'Frame Finder', href: '/ai/frame-finder' },
];
